import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICartItem } from '../../../components/pages/CartPage/components/CartItem/CartItem';
import getCart from './getCart';

const initialState: ICartItem[] = getCart();

const updateLocalStorage = (state: ICartItem[]) => {
  localStorage.setItem('products', JSON.stringify(state));
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<ICartItem>) => {
      const index = state.findIndex(
        (i) => i.product_id === action.payload.product_id,
      );
      if (index === -1) {
        state.push(action.payload);
      } else {
        state[index].count = state[index].count + action.payload.count;
      }
      updateLocalStorage(state);
    },
    removeItem: (state, action: PayloadAction<{ product_id: string }>) => {
      updateLocalStorage(
        state.filter((item) => item.product_id !== action.payload.product_id),
      );
      return state.filter(
        (item) => item.product_id !== action.payload.product_id,
      );
    },
    updateCount: (
      state,
      action: PayloadAction<{ product_id: string; count: number }>,
    ) => {
      const index = state.findIndex(
        (item) => item.product_id === action.payload.product_id,
      );
      state[index].count = action.payload.count;
      updateLocalStorage(state);
    },
    clearCart: () => {
      updateLocalStorage([]);
      return [];
    },
    updateComment: (
      state,
      action: PayloadAction<{ product_id: string; comment: string }>,
    ) => {
      const index = state.findIndex(
        (item) => item.product_id === action.payload.product_id,
      );
      state[index].comment = action.payload.comment;
      updateLocalStorage(state);
    },
  },
});

export const cartReducer = cartSlice.reducer;
export const cartActions = cartSlice.actions;
